export enum GTMUserRoles {
  VerifoneUser = 'VERIFONE_USER',
  ExternalUser = 'EXTERNAL_USER',
}
